{
  "login": {
    "title": "Entrar",
    "emailLabel": "Endereço de e-mail",
    "passwordLabel": "Senha",
    "rememberMe": "Lembrar de mim por 30 dias",
    "submitButton": "Entrar",
    "submittingButton": "Entrando...",
    "forgotPassword": "Esqueceu a senha?",
    "setNewPassword": "Defina uma nova senha aqui",
    "sessionExpired": "Sessão expirada",
    "noAccountYet": "Ainda não tem uma conta?",
    "createOne": "Crie uma"
  },
  "forgotPassword": {
    "title": "Esqueci a senha",
    "emailLabel": "Endereço de e-mail",
    "submitButton": "Enviar link de redefinição de senha para seu e-mail",
    "backToLogin": "Voltar para o login",
    "submittingButton": "Enviando...",
    "successTitle": "Verifique sua caixa de entrada",
    "successMessage": "Se existir uma conta para este endereço, enviamos um link de redefinição para seu e-mail."
  },
  "confirmEmail": {
    "confirming": "Confirmando seu e-mail…",
    "successTitle": "E-mail confirmado",
    "successMessage": "Seu endereço de e-mail foi confirmado. Agora você pode entrar na sua conta.",
    "continueToLogin": "Continuar para o login",
    "errorTitle": "Falha na confirmação",
    "errorMessage": "Não foi possível confirmar seu e-mail. O link pode ser inválido ou ter expirado."
  },
  "resetPassword": {
    "title": "Redefinir senha",
    "subtitle": "Digite sua nova senha abaixo",
    "newPasswordLabel": "Nova senha",
    "newPasswordPlaceholder": "Digite sua nova senha",
    "confirmPasswordLabel": "Confirmar nova senha",
    "confirmPasswordPlaceholder": "Confirme sua nova senha",
    "passwordsDoNotMatch": "As senhas não coincidem",
    "submitButton": "Definir nova senha",
    "submittingButton": "Redefinindo senha...",
    "invalidToken": "Token de redefinição inválido",
    "fixRequirements": "Corrija os requisitos da senha",
    "failedReset": "Falha ao redefinir a senha"
  },
  "acceptTerms": {
    "title": "Termos e condições",
    "subtitle": "Revise e aceite nossos termos para continuar",
    "welcomeTitle": "Bem-vindo ao Flipping Pal!",
    "welcomeBody": "Estes termos e condições descrevem as regras e regulamentos para o uso do site do Flipping Pal, localizado em",
    "welcomeBody2": "Ao acessar este site, assumimos que você aceita estes termos e condições. Não continue usando o Flipping Pal se não concordar com todos os termos e condições declarados nesta página.",
    "keyPointsTitle": "Pontos principais:",
    "keyPoints": {
      "0": "O Flipping Pal possui todos os direitos de propriedade intelectual sobre os materiais deste site",
      "1": "Você não pode republicar, vender ou redistribuir conteúdo do Flipping Pal",
      "2": "Usamos cookies para aprimorar sua experiência em nosso site",
      "3": "Os comentários dos usuários não refletem as opiniões do Flipping Pal",
      "4": "Reservamo-nos o direito de modificar estes termos a qualquer momento",
      "5": "O conteúdo do site é fornecido \"como está\" sem garantias"
    },
    "responsibilitiesTitle": "Suas responsabilidades:",
    "responsibilities": {
      "0": "Use o serviço de acordo com todas as leis aplicáveis",
      "1": "Mantenha a segurança das credenciais da sua conta",
      "2": "Não tente comprometer a segurança dos nossos sistemas",
      "3": "Respeite os direitos de propriedade intelectual"
    },
    "previewNote": "📄 Esta é uma prévia dos nossos Termos e condições. Clique em \"Ver termos completos\" para ler o documento completo.",
    "viewFullTerms": "Ver Termos e condições completos (abre em nova aba)",
    "checkboxLabel": "Li e aceito os Termos e condições",
    "checkboxDescription": "Ao marcar esta caixa, você reconhece que leu, compreendeu e concorda em ser vinculado por estes termos.",
    "acceptButton": "Aceitar e continuar",
    "acceptingButton": "Aceitando...",
    "questionsText": "Dúvidas sobre nossos termos?",
    "contactSupport": "Contatar suporte"
  },
  "discord": {
    "linkingTitle": "Vinculando conta Discord",
    "linkingBody": "Aguarde enquanto conectamos sua conta Discord...",
    "successTitle": "Sucesso!",
    "successBody": "Sua conta Discord foi vinculada com sucesso.",
    "successWindowClose": "Esta janela será fechada automaticamente...",
    "successRedirect": "Redirecionando para as configurações...",
    "errorTitle": "Vinculação falhou",
    "errorBody": "Não foi possível vincular sua conta Discord.",
    "errorWindowClose": "Esta janela será fechada automaticamente...",
    "errorRedirect": "Redirecionando para as configurações...",
    "backToSettings": "Voltar para configurações"
  },
  "register": {
    "title": "Criar conta",
    "subtitle": "Junte-se a nós e comece sua jornada hoje",
    "emailLabel": "Endereço de e-mail",
    "emailPlaceholder": "Digite seu endereço de e-mail",
    "passwordLabel": "Senha",
    "passwordPlaceholder": "Crie uma senha forte",
    "confirmPasswordLabel": "Confirmar senha",
    "confirmPasswordPlaceholder": "Confirme sua senha",
    "passwordStrength": "Força da senha",
    "strengthStrong": "Forte",
    "strengthMedium": "Média",
    "strengthWeak": "Fraca",
    "termsLabel": "Concordo com os",
    "termsLink": "Termos e condições",
    "termsLabel2": "",
    "submitButton": "Criar conta",
    "submittingButton": "Criando conta...",
    "alreadyHaveAccount": "Já tem uma conta?",
    "signInHere": "Entre aqui",
    "registrationClosed": "Registro não disponível no momento",
    "registrationClosedMessage": "No momento o registro está fechado",
    "fixFormErrors": "Por favor corrija os erros do formulário antes de enviar",
    "acceptTermsRequired": "Por favor aceite os Termos e condições para continuar",
    "registrationFailed": "Registro falhou. Por favor, tente novamente."
  },
  "errorBoundary": {
    "title": "Algo deu errado",
    "subtitle": "Ocorreu um erro inesperado. Não se preocupe — seus dados estão seguros.",
    "unknownError": "Erro desconhecido",
    "goHome": "Ir para o início",
    "reloadPage": "Recarregar página",
    "logout": "Sair",
    "showErrorDetails": "Mostrar detalhes do erro",
    "hideErrorDetails": "Ocultar detalhes do erro",
    "copyToClipboard": "Copiar para a área de transferência",
    "copied": "Copiado!",
    "copy": "Copiar",
    "errorLabel": "Erro",
    "componentStackLabel": "Pilha de componentes",
    "reference": "Referência"
  }
}
